<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<mat-accordion id="Review Detail">
  <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
    <mat-expansion-panel-header class="ia-mat-panel template-3-mat-panel">
      <div
        class="save_title w-100 d-flex align-items-center gap-2 justify-content-between"
      >
        <mat-panel-title>
          <span class="text-header inc-f"> Conditional Approval Actions </span>
        </mat-panel-title>
        <button
          *ngIf="!versionHistoryData.isVersonHistory"
          class="cursor-pointer text-primary save_btn mr-2"
          [disabled]="isButtonDisabled ? true : !userPermissionList?.SaveCondApprovalsData"
          (click)="saveConditionalApprovalsData(); $event.stopPropagation()"
        >
          <lucide-icon name="save" size="16" class="text-primary"></lucide-icon>
          Save
        </button>
      </div>
    </mat-expansion-panel-header>
    <div class="row ml-2 mt-1">
      <!-- <div class="col-lg-3 mb-3">
        <label class="control-label fw">Action Type</label>
        <mat-select
          class="select_border"
          [(ngModel)]="assessmentData.actionType"
          [disabled]="!userPermissionList?.ActionType"
        >
          <mat-option
            *ngFor="
              let option of interpretationAssessmentDropdownList.actionTypeList
            "
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-select>
      </div> -->
      <div class="col-lg-3 mb-3">
        <label class="control-label fw">Action Owner </label>
        <mat-chip-grid class="t3_matchip" #actionOwnerInputList>
          <ng-container *ngFor="let item of actionOwnerFilterList">
            <mat-chip-row
              [selectable]="true"
              [removable]="true"
              (removed)="removeActionOwner(item.value)"
              class="mat-chip-category"
            >
              {{ item.name }}
              <mat-icon
                matChipRemove
                *ngIf="userPermissionList?.ActionOwner"
                >cancel</mat-icon
              >
            </mat-chip-row>
          </ng-container>
          <input
            class="form-control form-control-sm mat-autodd-input border-bottom"
            #actionOwnerInput
            [formControl]="searchActionOwnerCntrl"
            [matAutocomplete]="actionOwnerAutoComplete"
            [matChipInputFor]="actionOwnerInputList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addActionOwner($event)"
            #actionOwnerAutoTrigger="matAutocompleteTrigger"
            placeholder="Type to filter or add new choice"
            [readonly]="!userPermissionList?.ActionOwner"
          />
        </mat-chip-grid>
        <mat-autocomplete
          #actionOwnerAutoComplete="matAutocomplete"
          (optionSelected)="selectedActionOwnerEvent($event)"
        >
          <mat-option
            *ngFor="let obj of searchedActionOwners"
            [value]="obj.value"
          >
            <span class="option">
              {{ obj.name }}
            </span>
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="col-lg-3 mb-3">
        <label class="control-label fw">Action Due Date</label>
        <div class="input-group input-group-sm">
          <input
            matInput
            [matDatepicker]="ActionDueDate"
            (click)="ActionDueDate.open()"
            class="form-control form-control-sm border-bottom"
            name="ActionDueDate"
            [(ngModel)]="assessmentData.actionDueDate"
            [disabled]="!userPermissionList?.ActionDueDate"
          />
          <div class="input-group-append">
            <span
              class="input-group-text fa fa-calendar"
              (click)="ActionDueDate.open()"
            ></span>
          </div>
        </div>
        <mat-datepicker #ActionDueDate></mat-datepicker>
      </div>
      <div class="col-lg-3 mb-3">
        <label class="control-label fw">Action Closed </label>
        <div class="input-group input-group-sm">
          <input
            matInput
            [matDatepicker]="ActionClosed"
            (click)="ActionClosed.open()"
            class="form-control form-control-sm border-bottom"
            name="ActionClosed"
            [(ngModel)]="assessmentData.actionClosed"
            [disabled]="!userPermissionList?.ActionClosed"
          />
          <div class="input-group-append">
            <span
              class="input-group-text fa fa-calendar"
              (click)="ActionClosed.open()"
            ></span>
          </div>
        </div>
        <mat-datepicker #ActionClosed></mat-datepicker>
      </div>
    </div>
    <div class="row ml-2 mt-1">
      <div class="col-lg-12">
        <div class="header-text">
          <span class="control-label fw d-block mb-2"> Action Details </span>
        </div>
        <app-ck-editor-revision
          *ngIf="user.fullName != '' && assessmentData.actionDetails != ''"
          class="ck_editor_min_height"
          [accessType]="accessType"
          [data]="assessmentData.actionDetails"
          [userInfo]="user"
          [noteId]="'ActionDetails'"
          [editorUsers]="assessmentData.muteActionDetailsUsers"
          [selfAssessmentId]="summaryDetailsId"
          (childVariableChange)="
            onChildVariableChangeMainT3($event, 'ActionDetails')
          "
          (saveEditorDate)="onEditorSaveMainT3($event)"
          [isSaveDisable]="!userPermissionList?.ActionDetails"
        ></app-ck-editor-revision>
      </div>
    </div>
    <div class="row ml-2 mt-1">
      <div class="col-lg-12">
        <div class="header-text">
          <span class="control-label fw d-block mb-2">
            Action Closure - Supporting Rationale
          </span>
        </div>
        <app-ck-editor-revision
          *ngIf="user.fullName != '' && assessmentData.actionClosure != ''"
          class="ck_editor_min_height"
          [accessType]="accessType"
          [data]="assessmentData.actionClosure"
          [userInfo]="user"
          [noteId]="'ActionClosure'"
          [editorUsers]="assessmentData.muteActionClosureUsers"
          [selfAssessmentId]="summaryDetailsId"
          (childVariableChange)="
            onChildVariableChangeMainT3($event, 'ActionClosure')
          "
          (saveEditorDate)="onEditorSaveMainT3($event)"
          [isSaveDisable]="!userPermissionList?.ActionClosure"
        ></app-ck-editor-revision>
      </div>
    </div>
    <div class="row ml-2 pt-3">
      <div
        class="col-12 d-flex align-items-center justify-content-between gap-1"
      >
        <span
          class="cursor-pointer"
          (click)="uploadEvidenceInterpretationForAction()"
        >
          <lucide-icon
            class="text-blue-lucide mr-1"
            size="15"
            name="upload"
          ></lucide-icon>
          <span class="text-blue fw"
            >Upload Evidence - Actions
            <i
              *ngIf="interpretationEvidanceLoader"
              class="fa fa-circle-o-notch fa-spin"
              style="font-size: 0.875rem; line-height: 1.5"
            ></i>
          </span>
          <input
            id="uploadEvidanceT3ForAction"
            (change)="handleFileInputForAction($event.target.files)"
            type="file"
            multiple
            style="display: none"
          /><br />
        </span>
      </div>
      <div
        class="col-lg-12 mt-3"
        *ngIf="selfAssessmentDocument.length > 0 && tabName == 'Interpretation'"
      >
        <ng-container *ngFor="let docs of selfAssessmentDocument">
          <div class="file-div text-center" *ngIf="docs.fileType === 7">
            <span
              class="fa fa-trash pull-right delete-docs"
              (click)="openDeleteModel(docs.id)"
            ></span>
            <span
              class="cursor-pointer"
              (click)="
                downloadDocument(docs.id, docs.fileName, docs.fileExtension)
              "
            >
              <i
                class="fa fa-file-text fa-2x"
                *ngIf="docs.fileExtension === '.txt'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-text-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.eml' || docs.fileExtension === '.msg'
                "
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-pdf-o fa-2x"
                *ngIf="docs.fileExtension === '.pdf'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.doc'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.docx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xls'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xlsx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-o fa-2x"
                *ngIf="docs.fileExtension === '.csv'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-code-o fa-2x"
                *ngIf="docs.fileExtension === '.xml'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-archive-o fa-2x"
                *ngIf="docs.fileExtension === '.zip'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpeg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.png'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-powerpoint-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.ppt' ||
                  docs.fileExtension === '.pptx'
                "
                aria-hidden="true"
              ></i>
            </span>
            <div class="data-div">{{ docs.fileName }}</div>
          </div>
        </ng-container>
      </div>
      <div
        class="col-lg-12 mt-3"
        *ngIf="selfAssessmentDocument.length > 0 && tabName == 'Judgement'"
      >
        <ng-container *ngFor="let docs of selfAssessmentDocument">
          <div class="file-div text-center" *ngIf="docs.fileType === 11">
            <span
              class="fa fa-trash pull-right delete-docs"
              (click)="openDeleteModel(docs.id)"
            ></span>
            <span
              class="cursor-pointer"
              (click)="
                downloadDocument(docs.id, docs.fileName, docs.fileExtension)
              "
            >
              <i
                class="fa fa-file-text fa-2x"
                *ngIf="docs.fileExtension === '.txt'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-text-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.eml' || docs.fileExtension === '.msg'
                "
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-pdf-o fa-2x"
                *ngIf="docs.fileExtension === '.pdf'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.doc'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.docx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xls'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xlsx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-o fa-2x"
                *ngIf="docs.fileExtension === '.csv'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-code-o fa-2x"
                *ngIf="docs.fileExtension === '.xml'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-archive-o fa-2x"
                *ngIf="docs.fileExtension === '.zip'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpeg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.png'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-powerpoint-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.ppt' ||
                  docs.fileExtension === '.pptx'
                "
                aria-hidden="true"
              ></i>
            </span>
            <div class="data-div">{{ docs.fileName }}</div>
          </div>
        </ng-container>
      </div>
      <div
        class="col-lg-12 mt-3"
        *ngIf="selfAssessmentDocument.length > 0 && tabName == 'Approach'"
      >
        <ng-container *ngFor="let docs of selfAssessmentDocument">
          <div class="file-div text-center" *ngIf="docs.fileType === 15">
            <span
              class="fa fa-trash pull-right delete-docs"
              (click)="openDeleteModel(docs.id)"
            ></span>
            <span
              class="cursor-pointer"
              (click)="
                downloadDocument(docs.id, docs.fileName, docs.fileExtension)
              "
            >
              <i
                class="fa fa-file-text fa-2x"
                *ngIf="docs.fileExtension === '.txt'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-text-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.eml' || docs.fileExtension === '.msg'
                "
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-pdf-o fa-2x"
                *ngIf="docs.fileExtension === '.pdf'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.doc'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.docx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xls'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xlsx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-o fa-2x"
                *ngIf="docs.fileExtension === '.csv'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-code-o fa-2x"
                *ngIf="docs.fileExtension === '.xml'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-archive-o fa-2x"
                *ngIf="docs.fileExtension === '.zip'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpeg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.png'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-powerpoint-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.ppt' ||
                  docs.fileExtension === '.pptx'
                "
                aria-hidden="true"
              ></i>
            </span>
            <div class="data-div">{{ docs.fileName }}</div>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
